Namespace 'Customer.Sessions'

class Customer.Sessions.CustomerSessionsChecker extends Backbone.Model

  initialize:(customerSession, customer_timeout_enabled)->
    @customerSession = customerSession
    @customerTimeoutEnabled = customer_timeout_enabled
    @timer = null

  updateSession:(customerSession, now) =>
    return if !@customerTimeoutEnabled
    data = {
      customer_session_id: customerSession.customerSessionId,
      operator_id: customerSession.operatorId,
      last_activity_time: now,
      customer_timeout_enabled: @customerTimeoutEnabled
    }
    Backbone.ajax({
      url: "/customer/dashboard/last_operator_activity",
      method: 'GET',
      data: data,
      dataType: "json",
      success: (response) =>
        @_handleResponse(response, customerSession)
    });

  _handleResponse:(response, customerSession)=>
    if response.status == 'logged_out'
      @_renderSessionExpired()
    if response.status == 'about_to_expire'
      @_checkAgainLaterAtTime(response, customerSession, 0)
      @trigger('customer_session:about_to_expire', response)
    if response.status == 'active'
      @_checkAgainLaterAtTime(response, customerSession, response.warn_expiration_secs_limit)
      @trigger('customer_session:still_active', response)

  _checkAgainLaterAtTime:(response, customerSession, warn_expiration_secs_limit)=>
    @customerSession = customerSession
    checkAgainIn = response.time_left_till_expiration
    checkAgainIn = Math.round(checkAgainIn)
    warnSafecheckAgainIn = checkAgainIn - warn_expiration_secs_limit
    warnSafecheckAgainIn = checkAgainIn if warnSafecheckAgainIn <= 0 #just in case. this should not happen
    @_setCheckAgainInterval(warnSafecheckAgainIn * 1000)

  _setCheckAgainInterval:(timeLeftTillExpiration)=>
    @_clearTimer()
    @timer = setTimeout(@doUpdateLastOperatorActivityAndCheckStatus, timeLeftTillExpiration)

  doUpdateLastOperatorActivityAndCheckStatus:=>
    @updateSession(@customerSession, @customerSession.lastActivityTime, @customerTimeoutEnabled)

  _clearTimer:()=>
    clearTimeout(@timer) if @timer

  _renderSessionExpired:=>
    @_clearTimer()
    window.location.href = '/customer/dashboard/session_expired'



